module.exports = __webpack_public_path__ + "static/media/texspace.a1f96281.png";